import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main className="pt-20 md:pt-24">
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <nav className="text-sm text-foreground-500 mb-6">
              <a href="/" className="hover:text-primary-600 transition-colors">Home</a>
              <span className="mx-2">/</span>
              <span className="text-foreground-700">Privacy Policy</span>
            </nav>
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">Privacy Policy</h1>
            <p className="text-foreground-600">Last updated: August 2026</p>
          </div>
        </section>
        <section className="w-full px-4 md:px-6 lg:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto space-y-6 text-foreground-700">
            <p>This Privacy Policy describes how cssbuybr.help collects, uses, and protects your information when you visit our website.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Information We Collect</h2>
            <p>We may collect basic usage data through cookies and analytics tools to improve our website experience. This includes page views, time spent on pages, and general geographic location.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">How We Use Information</h2>
            <p>We use collected information to improve our content, understand user needs, and optimize our website for better performance. We do not sell personal data to third parties.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Cookies</h2>
            <p>Our website may use cookies to store your language preference and basic session information. You can disable cookies in your browser settings.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">External Links</h2>
            <p>Our website contains links to external websites (including kaspreadsheet.com). We are not responsible for the privacy practices of those websites.</p>
            <h2 className="font-heading text-xl font-bold text-foreground-900 mt-8">Contact</h2>
            <p>For privacy-related questions, please contact us through the Contact page.</p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}